<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'app',
		components: {}
	}
</script>

<style>
	@import url('../public/main.css');
	@import url('assets/css/global.css');
	*,
	::after,
	::before {
		box-sizing: border-box;
	}
	#app {
		width: 100%;
		min-height: 100vh;
		background-color: #E4E6EC;
		font-size: 13px;
	}
	body {
		margin: 0;
		/* 苹果系统字体家族 */
		font-family: -apple-system, BlinkMacSystemFont, "San Francisco", "Helvetica Neue", Helvetica, Arial,"Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
	}
	.el-table .cell {
		word-break: normal !important;
	}
</style>
